<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>订单列表</b></p>

            <p style="display:inline-block;line-height: 40px;margin: 5px 0;">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待产</el-radio-button>
                    <el-radio-button label="1">生产中</el-radio-button>
                    <el-radio-button label="2">暂停</el-radio-button>
                    <el-radio-button label="3">完成</el-radio-button>

                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button round type="success" @click="openDialog">{{ newAdd }}</el-button>
            </p>
        </div>

        <el-table :data="orderList" style="width: 100%" highlight-current-row>
            <el-table-column prop="orderCode" label="订单编号" min-width="14%">
            </el-table-column>
            <el-table-column prop="orderCount" label="订单数量" min-width="8%" align="center">
            </el-table-column>
            <el-table-column prop="customer" label="客户" min-width="7%">
            </el-table-column>
            <el-table-column prop="salesman" label="业务员" min-width="7%">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="10%">
            </el-table-column>
            <el-table-column prop="moldCode" label="模具编号" min-width="10%" sortable>
            </el-table-column>
            <el-table-column prop="createdTime" label="下单日期" min-width="11%">
            </el-table-column>
            <el-table-column prop="deliveryTime" label="交货日期" min-width="11%">
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="7%">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="15%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" round size="small">
                        更改
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="warning" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="10" :page-count="pageCount" layout="prev, pager, next" :total="total"
                @current-change="pageClick" hide-on-single-page>
            </el-pagination>
        </div>

        <el-dialog title="订单详情" :visible.sync="dialogFormVisible" width="60%">
            <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">
                <el-form-item label="订单编号" required :label-width="formLabelWidth">
                    <el-input v-model="form.orderCode" autocomplete="off" style="width:220px" disabled></el-input>
                </el-form-item>
                <el-form-item label="订单数量" required :label-width="formLabelWidth">
                    <el-input-number v-model="form.orderCount" :step="1" :min="1" style="width:220px"></el-input-number>
                </el-form-item>

                <el-form-item label="客户" required :label-width="formLabelWidth" prop="customerAbbrev">
                    <!-- <el-input v-model="form.customer" autocomplete="off" style="width:220px"></el-input> -->
                    <el-select v-model="form.customerAbbrev" filterable remote reserve-keyword placeholder="请输入关键字"
                        :remote-method="searchCustomer" :loading="loading" @change="cusChange" style="width:220px">
                        <el-option v-for="item in form.customerList" :key="item.value" :label="item.customerAbbrev"
                            :value="item.customerId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="业务员" required :label-width="formLabelWidth" prop="salesman">
                    <el-select v-model="form.salesman" placeholder="请选择" style="width:220px">
                        <el-option v-for="item in form.empList" :key="item.value" :label="item.employeeName"
                            :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="产品名称" required :label-width="formLabelWidth" prop="productName">
                    <el-input v-model="form.productName" autocomplete="off" style="width:220px"></el-input>
                </el-form-item>
                <el-form-item label="模具编号" required :label-width="formLabelWidth" prop="moldCode">
                    <el-input v-model="form.moldCode" autocomplete="off" style="width:220px"
                        :disabled="moldCodeDisable"></el-input>
                </el-form-item>

                <el-form-item label="下单日期" required :label-width="formLabelWidth" prop="createdTime">
                    <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="交货日期" required :label-width="formLabelWidth" prop="deliveryTime">
                    <el-date-picker v-model="form.deliveryTime" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <div style="width:350px;display: inline-block;"></div>

                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input v-model="form.remark" autocomplete="off" type="textarea" style="width:570px"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="$event => addMoldOrder('ruleForm')" v-show="saveButtonVisible1">保
                    存</el-button>
                
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MoldOrder",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            orderList: [],
            dialogFormVisible: false,
            saveButtonVisible1: true,
            
            statusSearch: 0,
            form: {
                id: '',
                orderCode: '自动生成',
                orderCount: 1,
                customer: '',
                empList: [],
                salesman: '',
                salesmanId: '',
                productName: '',
                moldCode: '',
                createdTime: new Date(),
                deliveryTime: '',
                status: 0,
                remark: '',

                customerList:[],
                customerId:'',
                customerAbbrev:''
            },
            assemblyProgress: 0,
            polishProgress: 0,
            formLabelWidth: '120px',
            moldCodeDisable: false,
            newAdd: '\u3000新增订单\u3000',
            rules: {
                customerAbbrev: [
                    { required: true, message: '请选择客户', trigger: 'blur' },
                    { required: true, message: '请选择客户', trigger: 'change' }
                ],
                salesman: [
                    { required: true, message: '请选择业务员', trigger: 'blur' },
                    { required: true, message: '请选择业务员', trigger: 'change' }
                ],
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ],
                moldCode: [
                    { required: true, message: '请输入模具编号', trigger: 'blur' },
                    { required: true, message: '请输入模具编号', trigger: 'change' }
                ],
                createdTime: [
                    { required: true, message: '请选择下单日期', trigger: 'blur' },
                    { required: true, message: '请选择下单日期', trigger: 'change' }
                ],
                deliveryTime: [
                    { required: true, message: '请选择交货日期', trigger: 'blur' },
                    { required: true, message: '请选择交货日期', trigger: 'change' }
                ]
            },
            pageIndex:0,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        handleClick(row) {
            // console.log(row);
            this.form.id = row.id

            this.form.orderCode = row.orderCode
            this.form.orderCount = row.orderCount

            // this.form.customer = row.customer
            this.form.customerAbbrev = row.customerId
            this.form.customerId = row.customerId

            this.form.salesman = row.salesmanId
            this.form.productName = row.productName
            this.form.moldCode = row.moldCode
            this.form.createdTime = row.createdTime
            this.form.deliveryTime = row.deliveryTime
            this.form.status = null
            this.form.remark = row.remark

            this.moldCodeDisable = true
            this.dialogFormVisible = true
        },
        openDialog() {

            this.form.id=''
            this.form.orderCode ='自动生成'
            this.form.orderCount = 1

            // this.form.customer = ''
            this.form.customerAbbrev = ''

            this.form.salesman = ''
            this.form.productName = ''
            this.form.moldCode = ''
            this.form.createdTime = new Date()
            this.form.deliveryTime = ''
            this.form.status = 0
            this.form.remark = ''

            this.moldCodeDisable = false
            this.dialogFormVisible = true
            
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeMoldOrder(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        getAllEmp() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll",
                data: {
                    companyId: this.companyId,
                    pageIndex:-1,
                    pageNum:-1
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.empList = data.data
            })
        },
        addMoldOrder(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    this.$axios({
                        method: "post",
                        url: "/shiro/mold/order/add",
                        data: {
                            id: this.form.id,
                            orderCode: this.form.orderCode,
                            orderCount: this.form.orderCount,

                            customer: this.form.customerAbbrev,

                            salesman: this.form.salesman,
                            productName: this.form.productName,
                            moldCode: this.form.moldCode,

                            createdTime: this.form.createdTime,
                            deliveryTime: this.form.deliveryTime,
                            status: this.form.status,
                            remark: this.form.remark,
                            assemblyProgress: this.assemblyProgress,
                            polishProgress: this.polishProgress,
                            companyId: this.companyId
                        }, headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        this.$message(data.msg)

                        this.dialogFormVisible = false
                        this.getAll(this.statusSearch)
                    })
                } else {
                    // console.log('error submit!!');
                    return false
                }
            })

        },
        searchByStatus(val) {
            
            this.getAll(val)
        },
        removeMoldOrder(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/mold/order/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAll(this.statusSearch)
            })
        },
        getAll(val) {

            const formData = new FormData()
            formData.append('status', val)
            formData.append('assemblyProgress', 0)
            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', 10)

            this.$axios({
                method: "post",
                url: "/shiro/mold/order/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    });
                    return
                }

                this.orderList = data.data
                this.total = this.orderList[0].total
                this.pageCount = this.total % 10 == 0 ? this.total % 10 : this.total % 10 + 1
                for (let i in this.orderList) {
                    this.orderList[i].createdTime = this.$moment(this.orderList[i].createdTime).format("YYYY-MM-DD")
                    this.orderList[i].deliveryTime = this.$moment(this.orderList[i].deliveryTime).format("YYYY-MM-DD")

                    if (this.orderList[i].status == 0) {
                        this.orderList[i].status = '待产'
                    } else if (this.orderList[i].status == 1) {
                        this.orderList[i].status = '生产中'
                    } else if (this.orderList[i].status == 2) {
                        this.orderList[i].status = '暂停'
                    } else {
                        this.orderList[i].status = '完成'
                    }
                }
            })
        },
        getBaseCustomerAll(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/getAll",
                data: {
                    queryParam: val,
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.customerList = data.data
            })
        },
        searchCustomer(val) {
            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false
                    this.getBaseCustomerAll(val)
                }, 200)

            }
        },
        cusChange(value) {
            console.log(value)
            this.form.customerId = value

            this.getAllEmp()
        },
        pageClick(currentPage){
            
            this.pageIndex=(currentPage-1)*10
            this.getAll(this.statusSearch)
        }
    },
    mounted() {
        this.getAll(this.statusSearch)
        // this.getAllEmp()

        this.getBaseCustomerAll("")
    }
}
</script>

<style>
#order-header {
    height: 70px;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}
</style>